module.exports = __webpack_public_path__ + "img/569e1d5.png";